import { useEffect } from 'react';

const SITE_URL = 'https://mdlens.com';

const setMetaContent = (selector, attributes, content) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
};

const useSEO = (title, description) => {
  useEffect(() => {
    const canonicalPath = window.location.pathname.replace(/\/+$/, '') || '/';
    const canonicalUrl = `${SITE_URL}${canonicalPath}`;

    if (title) {
      document.title = title;
      setMetaContent('meta[property="og:title"]', { property: 'og:title' }, title);
      setMetaContent('meta[name="twitter:title"]', { name: 'twitter:title' }, title);
    }

    if (description) {
      setMetaContent('meta[name="description"]', { name: 'description' }, description);
      setMetaContent('meta[property="og:description"]', { property: 'og:description' }, description);
      setMetaContent('meta[name="twitter:description"]', { name: 'twitter:description' }, description);
    }

    setMetaContent('meta[property="og:url"]', { property: 'og:url' }, canonicalUrl);
    setMetaContent('meta[name="twitter:url"]', { name: 'twitter:url' }, canonicalUrl);

    let canonical = document.head.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', canonicalUrl);
  }, [title, description]);
};

export default useSEO;